import { useState } from 'react'
import { Container, Title, Button } from '@/components'
import styles from './styles.module.scss'
import thumbnailUrl from '/public/images/thumbnail.webp'
import playImageUrl from '/public/icons/play.svg'

import useClickWithScroll from '@/utils/browser/useClickWithScroll'

import Image from 'next/image'

const Video = () => {
  const { isHomePage, onClickItem } = useClickWithScroll()

  const [isVideoLoaded, setIsVideoLoaded] = useState(false)

  return (
    <section className={styles.video}>
      <Container classname={styles.video__container}>
        <Title Tag="h2" alignText="center" colorText="light">
          TREINOS <span>ONLINE AO VIVO</span>
        </Title>
        <p className="fgt-subtitle fgt-subtitle--light">
          Com mais de <strong>400 TREINOS AO VIVO por mês</strong>, você pode
          ter o corpo que sempre sonhou sem sair de casa!
        </p>

        <div className={styles.video__iframe}>
          {!isVideoLoaded ? (
            <div className={styles.video__thumbnailWrapper}>
              <Image
                src={thumbnailUrl}
                alt="Thumbnail do vídeo sobre treinos ao vivo"
                className={styles.video__thumbnail}
                width={1280}
                height={720}
              />
              <button
                onClick={() => setIsVideoLoaded(true)}
                className={styles.video__playButton}
                aria-label="Clique para assistir ao vídeo"
                id="btn-play-video"
              >
                <Image
                  src={playImageUrl}
                  alt="Play url"
                  width={90}
                  height={90}
                />
              </button>
            </div>
          ) : (
            <iframe
              width="100%"
              height="100%"
              src="https://www.youtube.com/embed/oM_SEnXbwH0?autoplay=1&rel=0&showinfo=0"
              title="Com treinos ao vivo durante todo o dia, você pode ter o corpo que sempre sonhou sem sair de casa!"
              frameBorder="0"
              modestbranding="1"
              playsInline="1"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
            ></iframe>
          )}
        </div>
      </Container>

      <div className="fgt-section__action">
        <Button
          id="btn-section-video"
          variant="primary"
          className={'fgt-section__action--button'}
          onClick={() => {
            onClickItem('comparePlans', 0)
          }}
        >
          QUERO FAZER PARTE
        </Button>
      </div>
    </section>
  )
}

export default Video
